import React, { FC } from 'react';

import { EvFlexRow, EvSwitch, EvTitle } from '@evinced-private/ui-common';

import {
	SHOW_ONLY_LATEST_TESTS_TOGGLE_ID,
	WEB_SDK_TESTS_PAGE_MAIN_TITLE_ID
} from 'data-automation-ids/WebSdkDataAutomationIds';
import { ProductFiltersPanelTrigger } from 'src/common/components/pinned-date-range-filters-panel';

import { WEB_SDK_TESTS_FILTER_SECTION_LABELS } from './WebSdkTestsFilterSection.labels';

interface WebSdkTestsFilterSectionTitleRowProps {
	showRecentTest: boolean;
	onShowRecentTestToggle: () => void;
}

export const WebSdkTestsFilterSectionTitleRow: FC<WebSdkTestsFilterSectionTitleRowProps> = ({
	showRecentTest,
	onShowRecentTestToggle
}) => {
	return (
		<EvFlexRow justify="SPACE_BETWEEN" align="CENTER" gap="MEDIUM" width="100%">
			<EvTitle
				titleText={WEB_SDK_TESTS_FILTER_SECTION_LABELS.PAGE_TITLE}
				dataAutomationId={WEB_SDK_TESTS_PAGE_MAIN_TITLE_ID}
				headingLevel={1}
				className="main-title page-heading"
			/>
			<EvFlexRow align="CENTER" gap="MEDIUM" width="auto">
				<EvSwitch
					dataAutomationId={SHOW_ONLY_LATEST_TESTS_TOGGLE_ID}
					onChange={onShowRecentTestToggle}
					checked={showRecentTest}
					label={WEB_SDK_TESTS_FILTER_SECTION_LABELS.SHOW_ONLY_LATEST_TESTS}
				/>
				<ProductFiltersPanelTrigger />
			</EvFlexRow>
		</EvFlexRow>
	);
};
